import { GripVertical, MessageCircle, Pencil } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import { Tooltip } from '@/components/ui/Tooltip'
import DeleteButton from '@/components/ui/DeleteButton'
import { LucideIcon } from '@/lib/lucideIconRegistry'

export interface Topic {
  id: string
  name: string
  icon: string | null
  description: string | null
  inbox_id: string
  inbox_name: string | null
  position: number
  active: boolean
  channel_ids: string[]
}

interface TopicListItemProps {
  topic: Topic
  onEdit: (topic: Topic) => void
  onDelete: (topicId: string) => void
}

export function TopicListItem({ topic, onEdit, onDelete }: TopicListItemProps) {
  return (
    <div className="flex items-center gap-3 p-3 bg-muted/50 rounded-lg group">
      <GripVertical className="size-4 text-muted-foreground opacity-0 group-hover:opacity-100 cursor-grab" />
      <span className="w-8 flex justify-center text-muted-foreground">
        {!topic.icon ? (
          <MessageCircle className="size-5" />
        ) : /^[a-z0-9-]+$/.test(topic.icon) ? (
          <LucideIcon name={topic.icon} className="size-5" />
        ) : (
          <span className="text-lg leading-none">{topic.icon}</span>
        )}
      </span>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className="font-medium">{topic.name}</span>
          {!topic.active && (
            <span className="text-xs bg-muted px-2 py-0.5 rounded">Inactive</span>
          )}
        </div>
        <div className="text-sm text-muted-foreground flex items-center gap-2">
          <span>→ {topic.inbox_name || 'No inbox'}</span>
          {topic.description && (
            <>
              <span>•</span>
              <span className="truncate">{topic.description}</span>
            </>
          )}
        </div>
      </div>
      <div className="flex items-center gap-1 opacity-0 group-hover:opacity-100">
        <Tooltip content="Edit topic">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onEdit(topic)}
            className="cursor-pointer"
          >
            <Pencil className="size-4" />
          </Button>
        </Tooltip>
        <DeleteButton
          onDelete={() => onDelete(topic.id)}
          initialText=""
          confirmText="Delete?"
        />
      </div>
    </div>
  )
}
